import React from 'react'
import HelpContent from './HelpContent'

export default function HelpPage () {
  return (
    <div className='helpPage web'>
      <HelpContent />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/help/HelpPage.jsx